import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useSnackbar } from "notistack";
import type { CreateCustomerRequest, CustomerResponse } from "./customersApi";
import { createCustomer } from "./customersApi";

export const useCreateCustomer = () => {
  const { enqueueSnackbar } = useSnackbar();
  const queryClient = useQueryClient();

  const createCustomerMutation = useMutation<CustomerResponse, unknown, { value: CreateCustomerRequest }>({
    mutationFn: ({ value }) => createCustomer(value),
    onSuccess: async (data) => {
      enqueueSnackbar(`Klient ${data.name} został utworzony`, { variant: "success" });
      await queryClient.invalidateQueries({ queryKey: ["customers"] });
    },
    onError: (error) => {
      enqueueSnackbar(`Nie udało się stworzyć klienta. Powód: ${(error as Error).message}`, { variant: "error" });
    },
  });

  return {
    createCustomer: (value: CreateCustomerRequest) => createCustomerMutation.mutateAsync({ value }),
  };
};
